import Handler from "./Handler";

// The signed-in person's own inbox, devices and settings. All calls are "silent": a failed
// background call must never throw the whole app to the Unauthorized screen.
const BASE = "/admin/notifications";

const read = (response) => (response?.success ? response?.data?.data || {} : null);

export const fetchNotifications = async ({ limit = 20, before, unread, category } = {}) => {
    const params = { limit };
    if (before) params.before = before;
    if (unread) params.unread = "1";
    if (category) params.category = category;
    return read(await Handler({ method: "get", url: BASE, params, silent: true }));
};

export const fetchUnreadCount = async () => read(await Handler({ method: "get", url: `${BASE}/unread-count`, silent: true }));

export const markNotificationsRead = async (payload) => read(await Handler({ method: "patch", url: `${BASE}/read`, data: payload, silent: true }));

export const fetchPreferences = async () => read(await Handler({ method: "get", url: `${BASE}/preferences`, silent: true }));

export const savePreferences = async (payload) => Handler({ method: "put", url: `${BASE}/preferences`, data: payload, silent: true });

export const saveDevice = async (info) => Handler({ method: "post", url: `${BASE}/devices`, data: info, silent: true });

export const removeDevice = async (token) => Handler({ method: "post", url: `${BASE}/devices/remove`, data: { token }, silent: true });
